import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { hasPermission } from "@/lib/permissions";

export default function PermissionGate({ section, level = "view", children }) {
  const { user, ready } = useAuth();
  if (!ready) return null;
  if (!hasPermission(user, section, level)) {
    return <Navigate to="/" replace />;
  }
  return children;
}
